<div class="page-center">
    <h3>There are no tests for this patient</h3>
</div>